var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.backgroundpage)?_c('div',{staticClass:"auth-layout",style:({ background: `url(${_vm.backgroundpage})` })},[_c('div',{staticClass:"auth-form"},[_c('router-view',{key:_vm.$route.fullPath})],1)]):_c('div',{staticClass:"auth-layout"},[_c('div',{staticClass:"auth-form"},[_c('router-view',{key:_vm.$route.fullPath})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }